import { astonCacheId, mergeRecursive } from '@aston/foundation/functions';
import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, map } from 'rxjs';

import { environment } from '../environments/environment';

export function translateLoader(http: HttpClient) {
	return new MultiTranslateHttpLoader(http, environment.translations.filenames.map(f => {
		return { prefix: './assets/i18n/' + f + '.', suffix: '.json' };
	}));
}


/* custom translation loader, extends the translation file to merge multiple files into a single one */

/* original => https://github.com/ngx-translate/http-loader/issues/44#issuecomment-412510056 */
export class MultiTranslateHttpLoader implements TranslateLoader {
	constructor(
		private http: HttpClient,
		public resources: { prefix: string, suffix: string }[] = [{ prefix: '/assets/i18n/', suffix: '.json' }]) {
	}

	public getTranslation(lang: string): any {
		return forkJoin(this.resources.map(config => {
			return this.http.get(`${config.prefix}${lang}${config.suffix}${astonCacheId()}`);
		})).pipe(map(response => {
			return response.reduce((a, b) => mergeRecursive(a, b));
		}));
	}
}
